module.exports = "https://cdn2-fs.clearscore.com/flux/images/5a7fd49ee05f0de86045949bae86c2d7.jpg";